<template>
  <div class="brains-scroll-tabs-container">
    <div class="brains-scroll-container">
      <div v-if="overflow" class="brains-scroll-tabs--overflow brains-scroll-tabs--overflow__left">
        <em class="el-icon-arrow-left" @click="scrollLeft()" />
      </div>
      <div :id="brainsScrollTabsId" class="brains-scroll-tabs">
        <div v-for="(tab, index) in tabs" :id="'brains-scroll-tab_' + tab.targetId" :key="index" class="brains-scroll-tabs--tab" :class="{ 'is-active': tab.isActive }">
          <div @click="selectTab(tab)">{{ tab.name }}</div>
        </div>
      </div>
      <div v-if="overflow" :class="{ 'brains-scroll-tabs--overflow__right-hidden' : rightScrollHidden }" class="brains-scroll-tabs--overflow brains-scroll-tabs--overflow__right">
        <em class="el-icon-arrow-right" @click="scrollRight()" />
      </div>
    </div>

    <div class="brains-scroll-tabs-details">
      <slot />
    </div>
  </div>
</template>

<script>
import { _ } from 'vue-underscore'
export default {
  name: 'BrainsScrollTabs',
  props: {
    scrollContainer: {
      type: String,
      default: ''
    },
    scrollBlock: {
      type: String,
      default: 'start'
    }
  },
  data() {
    return {
      tabs: [],
      randomNum: 0,
      scrollWidth: null,
      clientWidth: null,
      // Se establece un intervalo que ejecuta una función cada segundo hasta que el scroll este visible para poder saber si hay overflow o no
      sizeInterval: setInterval(this.initTabs, 1000),
      counter: 0,
      rightScrollHidden: false,
      isInitHeights: false,
      heights: [],
      scrolling: false
    }
  },
  computed: {
    brainsScrollTabsId() {
      return 'brains-scroll-tabs-' + this.randomNum
    },
    overflow() {
      if (this.clientWidth < this.scrollWidth) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    scrollWidth(newOne, oldOne) {
      if (newOne > 0 && newOne !== null) {
        clearInterval(this.sizeInterval)
      }
    },
    counter(newOne) {
      if (newOne < 0) {
        this.counter = 0
      }
    }
  },
  created() {
    this.generateRandomNum()
    this.tabs = this.$children
  },
  mounted() {
    var vm = this
    setTimeout(() => {
      this.initTabs()

      if (this.scrollContainer !== '') {
        var parent = document.getElementById(this.scrollContainer)

        var scrollControllerAUX = function() {
          if (!vm.isInitHeights) {
            vm.initHeights()
            return
          }
          if (vm.scrolling) { return }
          var scrollHeight = (window.pageYOffset || this.scrollTop) - (this.clientTop || 0)
          var itm = _.filter(vm.heights, function(item) { return item.height >= scrollHeight })[0]
          if (itm === null || itm === undefined) { return }
          var activeID = ''
          vm.tabs.forEach((tab) => {
            if (itm.id.includes(tab.targetId)) {
              activeID = tab.targetId
              tab.isActive = true
            } else {
              tab.isActive = false
            }
          })

          var containerElementDOM = document.getElementById(vm.brainsScrollTabsId)
          var itmElementDOM = document.getElementById('brains-scroll-tab_' + activeID)
          if (itmElementDOM === undefined || itmElementDOM === null || containerElementDOM === undefined || containerElementDOM === null) { return }
          var itmElement = itmElementDOM.getBoundingClientRect()
          var containerElement = containerElementDOM.getBoundingClientRect()
          var containerPosLeft = containerElement.left
          var itmPosLeft = itmElement.left

          if (((itmPosLeft + itmElement.width) >= (containerPosLeft + containerElement.width)) || (itmPosLeft <= containerPosLeft)) {
            document.getElementById(vm.brainsScrollTabsId).scrollBy(itmPosLeft - containerPosLeft, 0)
          }
        }
        parent.addEventListener('scroll', scrollControllerAUX)
      }
    }, 2000)
  },
  methods: {
    initHeights() {
      var vm = this
      var parent = document.getElementById(this.scrollContainer)
      var listArray = Array.from(parent.children)
      listArray = _.filter(listArray, function(item) {
        return item.id !== undefined && item.id !== null && !item.id.includes('container_loading')
      })

      for (var i = 0; i < listArray.length; i++) {
        var itmId = listArray[i].id
        var itmHeight = (i > 0 ? listArray[i].scrollHeight + vm.heights[i - 1].height : (listArray[i].scrollHeight * 0.1))
        vm.heights.push({ id: itmId, height: itmHeight })
      }

      vm.isInitHeights = true
    },
    scrollRight() {
      document.getElementById(this.brainsScrollTabsId).scrollBy(160, 0)
      setTimeout(() => {
        this.counter++
        if (this.clientWidth + document.getElementById(this.brainsScrollTabsId).scrollLeft >= this.scrollWidth) {
          this.rightScrollHidden = true
        }
      }, 350)
    },
    scrollLeft() {
      document.getElementById(this.brainsScrollTabsId).scrollBy(-160, 0)
      setTimeout(() => {
        this.counter--
        if (this.clientWidth + document.getElementById(this.brainsScrollTabsId).scrollLeft <= this.scrollWidth) {
          this.rightScrollHidden = false
        }
      }, 350)
    },
    initTabs() {
      var item = document.getElementById(this.brainsScrollTabsId)
      if (this.tabs === undefined || this.tabs.length === 0) { return }
      this.tabs[0].isActive = true
      if (item !== null && item !== undefined) {
        this.scrollWidth = item.scrollWidth
        this.clientWidth = item.clientWidth
      }
    },
    generateRandomNum() {
      this.randomNum = Math.floor(Math.random() * (9999 - 0)) + 0
    },
    selectTab(selectedTab) {
      this.scrolling = true

      var container = document.getElementById(this.scrollContainer)
      container.style.scrollBehavior = 'smooth'

      var target = container.querySelector('[id*="' + selectedTab.targetId + '"')

      container.scrollTop = (target.offsetTop - target.parentNode.offsetTop)
      this.$emit('selectedScrollTab', selectedTab)

      this.tabs.forEach((tab) => {
        tab.isActive = tab.name === selectedTab.name
      })
      setTimeout(() => {
        this.scrolling = false
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.brains-scroll-tabs-container {
  width: 100%;
  border-bottom: 1px solid #c0c4cc;
  border-top: 1px solid #c0c4cc;
  overflow: hidden;
  max-width: 770px;

  .brains-scroll-container {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: center;

    .brains-scroll-tabs {
      overflow-x: hidden;
      scroll-behavior: smooth;
      transition: all 1s;
      display: flex;
      justify-content: flex-start;
      gap: 30px;
      padding: 25px 0 7px 0; // Fix en el tamaño, no mostraba flecha
      width: 92%;
      align-items: center;

      &--tab {
        font-weight: 600;
        cursor: pointer;
        font-size: 16px;
        white-space: nowrap;

        &:hover {
          color: $primary-brains;
        }
      }

      &--overflow {
        width: 4%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        &__left-hidden {
          i {
            display: none;
          }
        }

        &__right-hidden {
          i {
            display: none;
          }
        }
      }

      .is-active {
        color: $primary-brains;
      }
    }
  }
}
</style>
